export const SectionHeader = ({ children, id }) => (
    <div className="mb-12 sm:mb-16">
        <h2
            id={id}
            data-testid={id ? `${id}-header` : undefined}
            className="font-mono text-xs sm:text-sm uppercase tracking-[0.4em] text-neutral-500"
        >
            {children}
        </h2>
        <div className="mt-4 h-px w-full bg-[#262626]" />
    </div>
);
